// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA5QSO2vWeM-2nDDVhtNml0zxUkw3AMTRA",
  authDomain: "amcilar.firebaseapp.com",
  databaseURL: "https://amcilar-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "amcilar",
  storageBucket: "amcilar.appspot.com",
  messagingSenderId: "448502367877",
  appId: "1:448502367877:web:d9952bcdf6742deb71cbec",
  measurementId: "G-1WGJKVD80F"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);

export {firebaseConfig , analytics};